/**
 * Toast store — §2.5b stacked toasts after rapid-scan Confirm (last 3).
 * Svelte 5 runes. $state/$derived module-level (class or object pattern).
 */

export interface ToastMsg {
	id: number;
	kind: 'success' | 'info' | 'warning' | 'error';
	text: string;
	undo?: () => void;
	createdAt: number;
	/** Override auto-dismiss window (ms). Default 5000. */
	duration?: number;
}

function createToastStore() {
	let messages = $state<ToastMsg[]>([]);
	let counter = 0;

	function push(msg: Omit<ToastMsg, 'id' | 'createdAt'>): number {
		const id = ++counter;
		const entry: ToastMsg = { id, createdAt: Date.now(), ...msg };
		// Keep last 3 (spec §2.5b rapid-scan stack)
		messages = [...messages, entry].slice(-3);
		const dwell = msg.duration ?? 5_000;
		setTimeout(() => dismiss(id), dwell);
		return id;
	}

	function dismiss(id: number) {
		messages = messages.filter((m) => m.id !== id);
	}

	function clear() {
		messages = [];
	}

	return {
		get messages() {
			return messages;
		},
		push,
		dismiss,
		clear
	};
}

export const toast = createToastStore();
